import React from 'react';

export function ThemePicker({ value, themes, onChange, className = '' }) {
  return (
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }} className={className}>
      {themes.map((theme) => (
        <button
          key={theme.id}
          type="button"
          aria-label={theme.name}
          title={theme.name}
          onClick={() => onChange(theme)}
          style={{
            width: 32,
            height: 32,
            borderRadius: 8,
            cursor: 'pointer',
            background: theme.background,
            border: value.id === theme.id ? '2px solid #374151' : '2px solid transparent',
            transform: value.id === theme.id ? 'scale(1.15)' : 'scale(1)',
            transition: 'all 0.15s',
            flexShrink: 0,
            padding: 0,
          }}
        />
      ))}
    </div>
  );
}

export default ThemePicker;
